import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import {
  DropdownModule,
  InputTextModule,
  InputNumberModule,
  RadioButtonModule,
  FileUploadModule,
  CheckboxModule,
  TooltipModule,
  ButtonModule,
  InputSwitchModule,
  InputTextareaModule,
  CalendarModule,
  ProgressSpinnerModule,
  TableModule,
} from 'primeng';
import { EnvironmentService } from '../services/environment.service';
import { NetzTranslationLoader } from '../services/netz-translation-loader';
import { RegepRoutingModule } from './regep-routing.module';
import { SharedModule } from '../+shared/shared.module';
import { GridApplicationSharedModule } from '../+grid-application-shared/grid-application-shared.module';
import { RegepOrderProcessComponent } from './components/regep-order-process/regep-order-process.component';
import { GridApplicationService } from '../+grid-application-shared/services/grid-application.service';
import { RegepApplicationService } from './services/regep-application.service';
import { RegepTechnicalFormComponent } from './technical-form/regep-technical-form.component';
import { RegepPersonalDataFormComponent } from './personal-data-form/regep-personal-data-form.component';
import { RegepDocumentsFormComponent } from './documents-form/regep-documents-form.component';
import { CommissioningOfEnergyProducerComponent } from './components/sections/commissioning-of-energy-producer/commissioning-of-energy-producer.component';
import { ProvisioningOfCurrentTransformersComponent } from './components/sections/provisioning-of-current-transformers/provisioning-of-current-transformers.component';
import { RegepTechnicalResourceComponent } from './components/regep-technical-resource/regep-technical-resource.component';
import { RegepResultComponent } from './components/regep-result/regep-result.component';
import { RegepCommentsService } from './services/regep-comments.service';
import { GridApplicationCommentsService } from '../+grid-application-shared/services/grid-application-comments.service';
import { TotalPowerValidDirective } from './directives/total-power-valid.directive';
import { RegepFeedInControllabilityComponent } from './components/sections/regep-feed-in-controllability/regep-feed-in-controllability.component';
import { RegulatoryDataFormComponent } from './regulatory-data-form/regulatory-data-form.component';
import { BankAccountDetailsComponent } from './components/sections/regulatory-data/bank-account-details/bank-account-details.component';
import { EnergyProducersAuthorizationComponent } from './components/sections/regulatory-data/energy-producers-authorization/energy-producers-authorization.component';
import { EnergyProducersRegistrationComponent } from './components/sections/regulatory-data/energy-producers-registration/energy-producers-registration.component';
import { ModelsFeedInCompensationComponent } from './components/sections/regulatory-data/models-feed-in-compensation/models-feed-in-compensation.component';
import { TaxPaymentDeclarationComponent } from './components/sections/regulatory-data/tax-payment-declaration/tax-payment-declaration.component';
import { WaiverFeedInCompensationComponent } from './components/sections/regulatory-data/waiver-feed-in-compensation/waiver-feed-in-compensation.component';

@NgModule({
  declarations: [
    RegepOrderProcessComponent,
    RegepTechnicalFormComponent,
    RegepPersonalDataFormComponent,
    CommissioningOfEnergyProducerComponent,
    ProvisioningOfCurrentTransformersComponent,
    RegepFeedInControllabilityComponent,
    RegepDocumentsFormComponent,
    RegepTechnicalResourceComponent,
    RegepResultComponent,
    TotalPowerValidDirective,
    RegulatoryDataFormComponent,
    BankAccountDetailsComponent,
    EnergyProducersAuthorizationComponent,
    EnergyProducersRegistrationComponent,
    ModelsFeedInCompensationComponent,
    TaxPaymentDeclarationComponent,
    WaiverFeedInCompensationComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RegepRoutingModule,
    SharedModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    RadioButtonModule,
    FileUploadModule,
    CheckboxModule,
    TooltipModule,
    ButtonModule,
    InputSwitchModule,
    InputTextareaModule,
    CalendarModule,
    TableModule,
    QuillModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: NetzTranslationLoader,
        deps: [HttpClient, EnvironmentService],
      },
    }),
    ProgressSpinnerModule,
    GridApplicationSharedModule,
  ],
  providers: [
    RegepApplicationService,
    {
      provide: GridApplicationService,
      useClass: RegepApplicationService,
    },
    RegepCommentsService,
    {
      provide: GridApplicationCommentsService,
      useClass: RegepCommentsService,
    },
  ],
})
export class RegepModule {}
